// Port of api/fuel/app/classes/insights/hindex/publishers.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'publishers',
    priority: 1,
    default_: true,
    requires: ['init'],
    insight: false,
    detail: [],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.track || !this._data.track.get_hindex()) return {}
        if (!owner.get_count_collection || !owner.get_count_collection()) return {}

        var collectionIndex = this._data.current.get_index_level()

        var limit = detail ? 100 : 5
        var ranked = []

        if (collectionIndex.length) {
            var versionRows = Util.query(
                'SELECT DISTINCT game_version_id AS version_id' +
                ' FROM game_publisher' +
                ' WHERE game_id IN (' + Util.in(collectionIndex) + ')' +
                ' AND game_publisher_primary = 1' +
                ' AND game_version_id <> 0'
            )
            var versionIndex = Util.pluck(versionRows, 'version_id')

            var sorted = Util.query(
                'SELECT COUNT(DISTINCT p.game_id) AS collected, p.publisher_id AS publisher' +
                ' FROM game_publisher p' +
                ' WHERE p.publisher_id NOT IN(1001, 4)' +
                ' AND p.game_publisher_primary = 1' +
                ' AND ((' +
                    'p.game_id IN (' + Util.in(collectionIndex) + ')' +
                    ' AND p.game_version_id = 0' +
                ')' + (versionIndex.length ? (
                    ' OR p.game_version_id IN (' + Util.in(versionIndex) + ')'
                ) : '') + ')' +
                ' GROUP BY p.publisher_id' +
                ' ORDER BY COUNT(DISTINCT p.game_id) DESC' +
                ' LIMIT 0, ' + limit
            )

            if (!sorted.length) {
                versionRows = Util.query(
                    'SELECT DISTINCT game_version_id AS version_id' +
                    ' FROM collection' +
                    ' WHERE user_id IN (' + Util.in(userIndex) + ')' +
                    ' AND game_id IN (' + Util.in(collectionIndex) + ')' +
                    ' AND game_version_id > 0'
                )
                versionIndex = Util.pluck(versionRows, 'version_id')
            }

            if (!sorted.length && versionIndex.length) {
                sorted = Util.query(
                    'SELECT COUNT(DISTINCT p.game_id) AS collected, p.publisher_id AS publisher' +
                    ' FROM game_publisher p' +
                    ' WHERE p.publisher_id NOT IN(1001, 4)' +
                    ' AND p.game_publisher_primary = 1' +
                    ' AND p.game_version_id IN (' + Util.in(versionIndex) + ')' +
                    ' GROUP BY p.publisher_id' +
                    ' ORDER BY COUNT(DISTINCT p.game_id) DESC' +
                    ' LIMIT 0, ' + limit
                )
            }

            if (!sorted.length) {
                sorted = Util.query(
                    'SELECT COUNT(*) AS collected, ranked.publisher_id AS publisher' +
                    ' FROM (' +
                        'SELECT gp.game_id, gp.publisher_id' +
                        ' FROM game_publisher gp' +
                        ' INNER JOIN (' +
                            'SELECT game_id, MIN(game_publisher_id) AS first_link' +
                            ' FROM game_publisher' +
                            ' WHERE game_id IN (' + Util.in(collectionIndex) + ')' +
                            ' AND publisher_id NOT IN(1001, 4)' +
                            ' GROUP BY game_id' +
                        ') picked ON picked.first_link = gp.game_publisher_id' +
                    ') ranked' +
                    ' GROUP BY ranked.publisher_id' +
                    ' ORDER BY COUNT(*) DESC' +
                    ' LIMIT 0, ' + limit
                )
            }

            var index = Util.pluck(sorted, 'publisher')

            if (index.length) {

                var applicableGames = Util.query(
                    'SELECT game_id AS game, publisher_id AS publisher' +
                    ' FROM game_publisher' +
                    ' WHERE publisher_id IN (' + Util.in(index) + ')' +
                    ' AND publisher_id NOT IN(1001, 4)' +
                    ' AND game_publisher_primary = 1' +
                    ' AND ((' +
                        'game_id IN (' + Util.in(collectionIndex) + ')' +
                        ' AND game_version_id = 0' +
                    ')' + (versionIndex.length ? (
                        ' OR game_version_id IN (' + Util.in(versionIndex) + ')'
                    ) : '') + ')'
                )

                if (!applicableGames.length && versionIndex.length) {
                    applicableGames = Util.query(
                        'SELECT game_id AS game, publisher_id AS publisher' +
                        ' FROM game_publisher' +
                        ' WHERE publisher_id IN (' + Util.in(index) + ')' +
                        ' AND publisher_id NOT IN(1001, 4)' +
                        ' AND game_publisher_primary = 1' +
                        ' AND game_version_id IN (' + Util.in(versionIndex) + ')'
                    )
                }

                if (!applicableGames.length) {
                    applicableGames = Util.query(
                        'SELECT gp.game_id AS game, gp.publisher_id AS publisher' +
                        ' FROM game_publisher gp' +
                        ' INNER JOIN (' +
                            'SELECT game_id, MIN(game_publisher_id) AS first_link' +
                            ' FROM game_publisher' +
                            ' WHERE game_id IN (' + Util.in(collectionIndex) + ')' +
                            ' AND publisher_id NOT IN(1001, 4)' +
                            ' GROUP BY game_id' +
                        ') picked ON picked.first_link = gp.game_publisher_id' +
                        ' WHERE gp.publisher_id IN (' + Util.in(index) + ')'
                    )
                }

                var applicableGameIndex = Util.pluck(applicableGames, 'game')
                var applicableGamesGrouped = {}

                for (var si = 0; si < applicableGames.length; si++) {
                    var link = applicableGames[si]
                    if (!applicableGamesGrouped[link.publisher]) applicableGamesGrouped[link.publisher] = []
                    applicableGamesGrouped[link.publisher].push(link.game)
                }

                var ratings = Util.query(
                    'SELECT AVG(r.rating_value) AS rating, r.game_id AS game' +
                    ' FROM rating r' +
                    ' WHERE r.game_id IN (' + Util.in(applicableGameIndex) + ')' +
                    ' AND r.user_id IN (' + Util.in(userIndex) + ')' +
                    ' GROUP BY r.game_id',
                    null, 'game'
                )

                var details = Util.query(
                    'SELECT * FROM publisher WHERE publisher_id IN (' + Util.in(index) + ')',
                    null, 'publisher_id'
                )

                for (var ri = 0; ri < sorted.length; ri++) {
                    var ritem = sorted[ri]
                    var gameRatings = []

                    if (applicableGamesGrouped[ritem.publisher]) {
                        for (var gj = 0; gj < applicableGamesGrouped[ritem.publisher].length; gj++) {
                            var gameId = applicableGamesGrouped[ritem.publisher][gj]
                            gameRatings.push({
                                id: parseInt(gameId, 10),
                                rating: (ratings[gameId] && ratings[gameId].rating) ? parseFloat(ratings[gameId].rating) : '-'
                            })
                        }
                    }

                    gameRatings = gameRatings.slice().sort(function(a, b) {
                        var ar = (a.rating === '-') ? 0 : a.rating
                        var br = (b.rating === '-') ? 0 : b.rating
                        return ar !== br ? br - ar : a.id - b.id
                    })

                    for (var gi = 0; gi < 3 && gi < gameRatings.length; gi++) {
                        this._references.games.push(gameRatings[gi].id)
                    }

                    ranked.push({
                        id: details[ritem.publisher] ? parseInt(details[ritem.publisher].publisher_id, 10) : parseInt(ritem.publisher, 10),
                        name: details[ritem.publisher] ? details[ritem.publisher].publisher_name : '',
                        count: parseInt(ritem.collected, 10),
                        games: gameRatings.slice(0, 3)
                    })
                }

            }

        }

        return {
            publishers: ranked
        }

    }
})
